import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-neutral-950 text-neutral-300 border-t border-neutral-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-8">
          <div>
            <Link to="/" className="inline-block mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_luxury-pergolas/artifacts/fvpheq93_IMG_0584.png" 
                alt="Hudson Knox" 
                className="h-10 w-auto brightness-0 invert"
              />
              <span className="block text-xs tracking-widest text-neutral-500 mt-2">OUTDOOR LIVING</span>
            </Link>
            <p className="text-sm text-neutral-400 leading-relaxed">
              Authorised Deponti stockist - supplying and installing premium aluminium pergolas and outdoor structures across South East England.
            </p>
          </div>

          <div>
            <h4 className="text-white text-sm font-medium tracking-wide mb-4">Services</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/services/pergola-installation" className="hover:text-white transition-colors">Pergola Installation</Link></li>
              <li><Link to="/services/motorised-pergolas" className="hover:text-white transition-colors">Motorised Pergolas</Link></li>
              <li><Link to="/services/pergola-blinds" className="hover:text-white transition-colors">Pergola Blinds</Link></li>
              <li><Link to="/services/glass-verandas" className="hover:text-white transition-colors">Glass Verandas</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white text-sm font-medium tracking-wide mb-4">Company</h4>
            <ul className="space-y-2 text-sm">
              <li><Link to="/projects" className="hover:text-white transition-colors">Projects</Link></li>
              <li><Link to="/locations" className="hover:text-white transition-colors">Locations</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white text-sm font-medium tracking-wide mb-4">Contact</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start space-x-2">
                <Phone className="h-4 w-4 mt-0.5 flex-shrink-0" />
                <a href="tel:07846923387" className="hover:text-white transition-colors">07846 923387</a>
              </li>
              <li className="flex items-start space-x-2">
                <Mail className="h-4 w-4 mt-0.5 flex-shrink-0" />
                <a href="mailto:admin@hudsonknox.co.uk" className="hover:text-white transition-colors">admin@hudsonknox.co.uk</a>
              </li>
              <li className="flex items-start space-x-2">
                <MapPin className="h-4 w-4 mt-0.5 flex-shrink-0" />
                <span>South East England</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-neutral-900 text-center text-sm text-neutral-500">
          <p>&copy; {currentYear} Hudson Knox Ltd. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};
